import {Route, Routes, useNavigate} from 'react-router-dom';
import { MainPage } from '../pages/main/MainPage';
import { SignerPage } from '../pages/signer/SignerPage';
import { ValidatorPage } from '../pages/validator/ValidatorPage';
import { Navbar } from '../components/NavBar';
import { SignDocument } from "../pages/signer/SignDocument";
import { ValidatedPage } from '../pages/validator/ValidatedPage';
import { RseValidatedPage } from '../pages/validator/RseValidatedPage';
import {SharedDocument} from "../pages/signer/SharedDocument";
import Footer from '../components/Footer';
import {useBaseURL} from "../context/BaseURLContext";
import {useEffect, useState} from "react";
import {getConfigurations} from "../services/configService";
import {SignCallbackPage} from "../pages/signer/SignCallbackPage";


const VALIDATOR_BASE_URL = process.env.REACT_APP_VALIDATOR_BASE_URL;

export const PageRouter = ({fileName, setFileName}) => {
    const baseURL = useBaseURL();
    const navigate = useNavigate();

    const [configLoaded, setConfigLoaded] = useState(false);
    const [initialConfig, setInitialConfig] = useState(null);

    useEffect(() => {
        const loadConfigurations = async () => {
            let configurations;
            const sessionConfig = sessionStorage.getItem('configs');
            if (sessionConfig) {
                configurations = JSON.parse(atob(sessionConfig));
            } else {
                configurations = await getConfigurations();
                sessionStorage.setItem('configs', btoa(JSON.stringify(configurations)));
            }
            setInitialConfig(configurations);
            setConfigLoaded(true); // Configuración cargada y lista
        };

        loadConfigurations();
    }, []);

    useEffect(() => {
        if (baseURL.includes(VALIDATOR_BASE_URL) && (window.location.pathname === '/' || /^\/signer(\/.*)?$/.test(window.location.pathname))) {
            navigate('/validator');
        }
    }, [baseURL, navigate]);
    return (
        <>
                <Navbar />
                <Routes>
                    <Route path='/' element={<MainPage initialConfig={initialConfig} />} />
                    <Route path='/signer' element={<SignerPage setFileName={setFileName}/>} />
                    <Route path='/validator' element={<ValidatorPage />} />
                    <Route path='signer/signDocument' element={<SignDocument fileName={fileName}/>} />
                    <Route path='signer/sharedDocument' element={<SharedDocument fileName={fileName}/>} />
                    <Route path='signer/callback' element={<SignCallbackPage />} />
                    <Route path='/validated' element={<ValidatedPage />} />
                    <Route path='/validated/rse' element={<RseValidatedPage />} />
                </Routes>
                <Footer/>
        </>
    )
}